import { debounce } from 'lodash-es';

const DEFAULT_DEBOUNCE_DELAY = 250; // Default debounce delay in milliseconds
/**
 * No debounce - each click event will be tracked:
 * <div v-track:click="{ label: 'name', props: {} }" />
 *
 * Default debounce (250ms):
 * <div v-track:click.debounce="{ label: 'name', props: {} }" />
 *
 * Custom debounce (500ms):
 * <div v-track:click.debounce-500="{ label: 'name', props: {} }" />
 */
const trackDirective = {
  bind(el, binding, vnode) {
    const { arg: action, value, modifiers } = binding;
    const { label, ...props } = value;
    const eventHandler = () => {
      if (vnode.context) {
        window.analytics?.track(label, props);
      }
    };
    // Extract debounce delay from modifiers
    const debounceModifier = Object.keys(modifiers).find((modifier) => modifier.startsWith('debounce'));
    const delay = debounceModifier ? parseInt(debounceModifier.split('-')[1] || DEFAULT_DEBOUNCE_DELAY, 10) : 0;
    const wrappedHandler = delay > 0 ? debounce(eventHandler, delay) : eventHandler;

    el.addEventListener(action, wrappedHandler);
    el._v_track_eventHandler = { handler: wrappedHandler, action };
  },
  unbind(el) {
    const { handler, action } = el._v_track_eventHandler;

    el.removeEventListener(action, handler);
    delete el._v_track_eventHandler;
  },
};

export default trackDirective;
